'use strict';

var styled = require('styled-components');
var cell = require('./Cells/cell.js');
require('./Cells/cellActions.js');
require('react');
require('./Cells/cellCheckbox.styles.js');
require('../Chip/component.js');
require('../Tooltip/component.js');
require('./Cells/cellIcon.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('../forms/Select/multi-select/OptionMulti.js');
require('../forms/Select/multi-select/ControlMulti.js');
require('./Cells/cellSubText.styles.js');
require('../forms/Switch/component.js');
require('../Tag/component.js');
require('./Cells/header.js');
require('../Icon/component.js');
var cell_styles = require('./Cells/cell.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const FillingDiv = styled__default.default.div `
  // Height + vertical margin need to sum to line-height of cell text - 1.5rem
  margin: 8px 0;
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(0.25turn, ${({ theme }) => `${theme.colors.border}, ${theme.colors.hover}`});
  animation: gradient 3s ease infinite;
  background-size: 200% 200%;
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
const TableStyled = styled__default.default.table `
  table-layout: ${({ tableLayout }) => tableLayout};
  border-collapse: collapse;
  width: 100%;
  background-color: white;
  td,
  th {
    vertical-align: middle;
  }
`;
const EmptyCell = styled__default.default(cell.Cell) `
  text-align: center;
  vertical-align: middle;
  line-height: 1rem;
  padding: 1.5rem;
  white-space: normal;
  ${cell_styles.CellContentStyled} {
    white-space: normal;
  }
`;
const EmptyCellSecondaryText = styled__default.default.div `
  color: ${({ theme }) => theme.palette.grey500};
`;
const ActionMenuContainer = styled__default.default.div `
  display: flex;
  margin-bottom: 1rem;
`;
const RightActionMenuContainer = styled__default.default.div `
  margin-left: auto;
`;

exports.ActionMenuContainer = ActionMenuContainer;
exports.EmptyCell = EmptyCell;
exports.EmptyCellSecondaryText = EmptyCellSecondaryText;
exports.FillingDiv = FillingDiv;
exports.RightActionMenuContainer = RightActionMenuContainer;
exports.TableStyled = TableStyled;
//# sourceMappingURL=table.styles.js.map
